var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-container",style:(_vm.style),attrs:{"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset}})}
var staticRenderFns = []

export { render, staticRenderFns }